module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', {
    attrs: {
      "id": "waterfall-pu-bu-liu"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#waterfall-pu-bu-liu",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" Waterfall 瀑布流")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "ji-chu-yong-fa"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#ji-chu-yong-fa",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" 基础用法")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "hljs language-html"
  }, [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"waterfall\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-waterfall-lower")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"loadMore\"")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-waterfall-upper")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"loadMoreUpper\"")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("waterfall-disabled")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"isWaterfallDisabled\"")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("waterfall-offset")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"400\"")]), _vm._v("\n  >")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"waterfall-item\"")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-for")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"item in list\"")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"text-align: center;\"")]), _vm._v("\n    >")]), _vm._v("\n      "), _c('span', [_vm._v("{{")]), _vm._v(" item "), _c('span', [_vm._v("}}")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-if")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"loading\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"text-align: center;\"")]), _vm._v(">")]), _vm._v("\n      loading\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _c('span', {
    staticClass: "javascript"
  }, [_vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  data() {\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" {\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("list")]), _vm._v(": ["), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("2")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("3")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("4")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("5")]), _vm._v("],\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loading")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("finished")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v("\n    };\n  },\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("methods")]), _vm._v(": {\n    loadMore() {\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("if")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".list.length >= "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("200")]), _vm._v(") {\n        "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".finished = "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v(";\n        "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(";\n      }\n\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".loading = "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v(";\n      setTimeout("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("()")]), _vm._v(" =>")]), _vm._v(" {\n        "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("let")]), _vm._v(" lastNumber = "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".list["), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".list.length - "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1")]), _vm._v("];\n        "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("for")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("let")]), _vm._v(" i = "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v("; i < "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("5")]), _vm._v("; i ++) {\n          lastNumber += "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1")]), _vm._v(";\n          "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".list.push(lastNumber);\n        }\n        "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".loading = "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(";\n      }, "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("2500")]), _vm._v(");\n    },\n    loadMoreUpper() {\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("if")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".list["), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v("] < "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v(") "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(";\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".list.unshift("), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("-1")]), _vm._v(");\n    }\n  },\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("computed")]), _vm._v(": {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("isWaterfallDisabled")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v("("), _c('span', {
    staticClass: "hljs-params"
  }), _vm._v(") ")]), _vm._v("{\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".loading || "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".finished;\n    }\n  }\n};\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "api"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#api",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" API")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("可选值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("waterfall-disabled")]), _vm._v(" "), _c('td', [_vm._v("是否禁止瀑布流触发")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("waterfall-offset")]), _vm._v(" "), _c('td', [_vm._v("触发瀑布流加载的阈值")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("300")]), _vm._v(" "), _c('td')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-180fd02e!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/waterfall-14.vue
// module id = 239
// module chunks = 0